import { useSelector } from 'react-redux';

import { FormattedTag } from 'shared/models/FormattedTag';
import { tagsListSelector } from 'shared/store/data/filters/selectors/smart/tagsListSelector';

export const useTags = (): FormattedTag[] => {
  return useSelector(tagsListSelector);
};
